{
  "newAnnouncement": "Has new announcement",
  "notification": "Notifications and Announcements",
  "unread": "unread notifications"
}
